import { render, staticRenderFns } from "./DashboardSummaryTable.vue?vue&type=template&id=f1a5cc96&scoped=true"
import script from "./DashboardSummaryTable.vue?vue&type=script&lang=js"
export * from "./DashboardSummaryTable.vue?vue&type=script&lang=js"
import style0 from "./DashboardSummaryTable.vue?vue&type=style&index=0&id=f1a5cc96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a5cc96",
  null
  
)

export default component.exports